import React, { useMemo } from "react";
import EChart from "./EChart";
import { ECHART_COLORS } from "../../Utilities/echartsTheme";

const EChartsSparkline = ({ data, color }) => {
  const option = useMemo(() => {
    const values = Array.isArray(data) ? data : [];
    const lineColor = color || ECHART_COLORS.primaryLight;

    return {
      grid: { left: 0, right: 0, top: 2, bottom: 2 },
      xAxis: { type: "category", show: false, data: values.map((_, i) => i) },
      yAxis: { type: "value", show: false },
      tooltip: { show: false },
      series: [
        {
          type: "line",
          data: values,
          smooth: true,
          symbol: "none",
          lineStyle: { width: 1.5, color: lineColor },
          areaStyle: {
            color: {
              type: "linear",
              x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: `${lineColor}40` },
                { offset: 1, color: `${lineColor}05` },
              ],
            },
          },
          animation: false,
        },
      ],
    };
  }, [data, color]);

  return <EChart option={option} style={{ height: 32 }} />;
};

export default EChartsSparkline;
